// Module
var code = "# if (data.Row.length > 0) { #\n    # for (var col = 0, colCount = data.Row.length; col < colCount; col++) { #\n        #= data.Board.boardColumn({ DataRow: data.DataRow, Column: data.Row[col], Board: data.Board, ColumnCount: colCount }) #\n    # } #\n# } #";
// Exports
export default code;